/**
 * @module customerTypes
 * @description A list of customerTypes
 */

export const customerTypes = [
	'commercial',
	'non-profit',
	'government',
	'parastatal',
	'individual',
	'other',
] as const;
export type CustomerTypes = (typeof customerTypes)[number];
